import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import { normalizeSupportChatConversation } from '@/lib/helpers/support-chat';
import type { RequestResponse, SupportChatConversation } from '@/types';

export const fetchSupportChatConversation = async () => {
  const response = await axiosInstance<
    RequestResponse<SupportChatConversation | Record<string, unknown>>
  >(endpoints.support.chatConversation);

  const payload = response.data.data;
  const normalized = normalizeSupportChatConversation(payload);
  if (normalized) return normalized;

  return null;
};
